import APIRoutes from './APIRoutes';

export default APIRoutes;
